/**
 * Late fee type discriminator
 */
export enum LateFeeTypeEnum {
	PER_HOUR = 'per_hour',
	PER_DAY = 'per_day',
	FLAT = 'flat',
	PERCENTAGE = 'percentage',
}
